import styled from 'styled-components'
import { incidentReportsConstants } from 'locale/incidentReports'
import { containsImageExtension } from '../../utils'
import { CloudDownloadOutlined } from '@ant-design/icons'
import DownloadFile from '../DownloadFile'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'

type AttachmentsRowProps = {
  attachments: string[]
}

const AttachmentsRow = ({ attachments }: AttachmentsRowProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <AttachmentsFlexRow>
      {attachments.map((url, index) =>
        containsImageExtension(url) ? (
          <DownloadFile fileName="file" fileUrl={url}>
            <AttachmentContainer>
              <ImageAttachment src={url} alt={`attached image ${index + 1}`} />
              <StyledCloudDownloadOutlined />
            </AttachmentContainer>
          </DownloadFile>
        ) : (
          <DownloadFile fileName="file" fileUrl={url}>
            <FileAttachment>
              <CloudDownloadOutlined />
              {t(incidentReportsConstants.FILE)}
            </FileAttachment>
          </DownloadFile>
        )
      )}
    </AttachmentsFlexRow>
  )
}

const AttachmentsFlexRow = styled.div`
  display: flex;
  gap: 8px;
  margin: 4px 0;
`

const AttachmentContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 58px;
  height: 72px;
  border-radius: 9px;
  &:hover {
    img {
      opacity: 0.3;
    }
    svg {
      visibility: visible;
    }
  }
`

const ImageAttachment = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 9px;
  object-fit: cover;
`

const StyledCloudDownloadOutlined = styled(CloudDownloadOutlined)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: hidden;
`

const FileAttachment = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 58px;
  height: 72px;
  border-radius: 9px;
  object-fit: cover;
  background-color: ${({ theme }) => theme.color.neutral.color9};
  border: 1px solid ${({ theme }) => theme.color.neutral.color7};
  &:hover {
    background-color: ${({ theme }) => theme.color.neutral.color10};
  }
`

export default AttachmentsRow
